import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";
import AgeGate from "./AgeGate";
import CartDrawer from "./CartDrawer";
import { Toaster } from "../components/ui/sonner";

const TOAST_OPTIONS = {
    style: {
        background: "var(--vl-surface)",
        border: "1px solid var(--vl-border)",
        color: "var(--vl-text)",
        borderRadius: 0,
    },
};

export default function Layout({ children }) {
    return (
        <>
            <AgeGate />
            <Navbar />
            <main>{children}</main>
            <Footer />
            <WhatsAppButton />
            <CartDrawer />
            <Toaster
                theme="dark"
                position="bottom-center"
                toastOptions={TOAST_OPTIONS}
            />
        </>
    );
}
